export default `p=fract(p)-.5;
    float s=3., l;
    for(int j=0;j++<8;)
      p=abs(p),
      p=p.x<p.y?p.zxy:p.zyx,
      s*=l=2./min(dot(p,p),1.),
      p=p*l-vec3(.2,1.0,4.0);
    return length(p)/s;
  }`